import React, {useEffect} from 'react';
import {ISeo} from 'modules/seo/types';
import {Toast} from 'components/Toast';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {useRouter} from 'next/router';
import {toast} from 'react-toastify';
import style from 'modules/product-card/pages/ProductPage/style.module.scss';
import {REDIRECT_INFORMER_TEXT, REDIRECT_SOURCE_STORAGE_KEY} from 'modules/product-card/constants';
import {getRedirectParamValue, withRedirectParam} from 'modules/product-card/helpers/redirect';

const INFORMER_CLOSE_DELAY = 5_000;

interface IUseRedirect {
    redirect?: ISeo['redirect'] | null;
}

export const useRedirect = ({redirect}: IUseRedirect) => {
    const productData = useAppSelector(selectProductData);
    const router = useRouter();

    useEffect(() => {
        const isRedirectAllowed = !getRedirectParamValue(router.asPath);

        if (isRedirectAllowed && redirect?.code && productData?.code !== redirect?.code) {
            const redirectSource = JSON.stringify(redirect);

            if (redirect.showInformer && redirect?.redirectedProductTitle) {
                window.sessionStorage.setItem(REDIRECT_SOURCE_STORAGE_KEY, redirectSource);
            }

            router.replace({pathname: router.pathname, query: {code: redirect?.code}}).then(() => {});
        }
    }, [productData?.code, router, redirect]);

    useEffect(() => {
        const redirectSource = JSON.parse(window.sessionStorage.getItem(REDIRECT_SOURCE_STORAGE_KEY) || '{}');
        if (redirectSource && 'code' in redirectSource) {
            const source = redirectSource as ISeo['redirect'];

            if (productData?.code === source?.code) {
                toast(
                    <Toast
                        hasIcon={false}
                        closeOnClick={true}
                        closeOnClickOutside={true}
                        className={style.toast}
                        text={`${source?.redirectedProductTitle} ${REDIRECT_INFORMER_TEXT}`}
                        path={withRedirectParam(`/catalog/product/${source?.redirectedProductCode}`)}
                        theme={'notification'}
                    />,
                    {
                        autoClose: INFORMER_CLOSE_DELAY,
                    },
                );
            } else if (productData?.code === source?.redirectedProductCode) {
                return;
            }
            window.sessionStorage.removeItem(REDIRECT_SOURCE_STORAGE_KEY);
        }
    }, [productData?.code]);
};
